import React from "react";
import moment from "moment";

import OoPopover from "../../../components/UI/Popover/OoPopover";
import {
  APPLICABLE_USER_FILE_LABEL,
  APPLICABLE_USER_FILE_TOOLTIP,
  EDIT_APPLICABLE_USER_FILE_POPOVER_HEADER,
  EDIT_FILE_UPLOADED_LABEL,
  EDIT_PUBLISHED_ON_PREFIX,
  EDIT_VIEW_FILE_LINK,
} from "./editCopy";

// Published-date + applicable-user-file meta, left column of a Trivvy / KC.
// `latestFileName` is the already-resolved display name, not the stored key.
const EditPublishedMeta = ({
  currentTrivia,
  latestFileName,
  uploadedAt,
  onViewFile,
  showFileMeta,
}) => {
  return (
    <React.Fragment>
      <div className="mt-4 trivia-edit-meta">
        {currentTrivia.isPublished && currentTrivia.publishedDate && (
          <React.Fragment>
            {EDIT_PUBLISHED_ON_PREFIX}{" "}
            {moment(currentTrivia.publishedDate).format(
              "MMM D, YYYY [at] h:mm A"
            )}{" "}
          </React.Fragment>
        )}
      </div>
      {showFileMeta && currentTrivia.isPublished && (
        <div className="mt-2 trivia-edit-meta">
          <p className="mb-1">
            <span style={{ whiteSpace: "nowrap" }}>
              {APPLICABLE_USER_FILE_LABEL}
              <OoPopover
                target="applicable_user_file_tooltip"
                headerText={EDIT_APPLICABLE_USER_FILE_POPOVER_HEADER}
                bodyText={APPLICABLE_USER_FILE_TOOLTIP}
                css_class="oo_popover_insights_tip"
              />
            </span>
          </p>
          <p>
            {latestFileName}, {EDIT_FILE_UPLOADED_LABEL}{" "}
            {moment(uploadedAt).format("MMM D, YYYY")}
            <a href="#" onClick={onViewFile} className="bwai-edit-inline-link ml-1">
              {EDIT_VIEW_FILE_LINK}
            </a>
          </p>
        </div>
      )}
    </React.Fragment>
  );
};

export default EditPublishedMeta;
